// removed by extract-text-webpack-plugin
module.exports = {"nav-container":"Mobile__nav-container__1KPpu","copyright":"Mobile__copyright__2O-2R","explanations":"Mobile__explanations__1wDji"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Mobile/Mobile.scss
// module id = 708
// module chunks = 0